import { apiClient } from './axios';

// ── Request/Response Types ──────────────────────────────────────────────────

export interface MintNFTRequest {
  petId: string;
  imageKey: string;
  artworkType: string;
  frame?: string;
  background?: string;
  caption?: string;
  seasonTheme?: string;
}

export interface MintNFTResponse {
  id: string;
  nftMintAddress: string;
  txSignature: string;
  name: string;
  network: string;
  explorerUrl: string;
  message: string;
}

export interface NFTItem {
  id: string;
  petId: string;
  nftMintAddress: string;
  txSignature: string;
  name: string;
  imageUrl: string | null;
  artworkType: string;
  frame: string | null;
  background: string | null;
  caption: string | null;
  seasonTheme: string | null;
  network: string;
  hidden: boolean;
  createdAt: string;
  explorerUrl: string;
}

export interface ListNFTsResponse {
  nfts: NFTItem[];
  total: number;
}

// ── API Functions ───────────────────────────────────────────────────────────

/**
 * Mint an NFT on Solana. The backend handles the full transaction.
 * Prerequisites: user must have a wallet and sufficient $PET balance.
 */
export async function mintNFT(request: MintNFTRequest): Promise<MintNFTResponse> {
  const response = await apiClient.post<MintNFTResponse>('/nft/mint', request);
  return response.data;
}

/**
 * List the authenticated user's minted NFTs. Optionally filter by pet.
 */
export async function listNFTs(petId?: string): Promise<ListNFTsResponse> {
  const params = petId ? { petId } : {};
  const response = await apiClient.get<ListNFTsResponse>('/nft/list', { params });
  return response.data;
}
